import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import First from "./First_section/First";
import Second from "./Second_section/Second";

const Portfolio = () => {
  return (
    <>
      <Header />
      <First />
      <Second />
      <Footer />
    </>
  );
};

export default Portfolio;
